export type SocialPlatformId = 'youtube' | 'instagram' | 'facebook';

export interface SocialMediaEntry {
  id: SocialPlatformId;
  label: string;
  /** When empty, the entry is shown as text only (no link). */
  url: string;
  username: string;
  iconClass: string;
  linkClass: string;
}

/** Centralized social links — update URLs here when Instagram/Facebook profiles are finalized. */
export const SOCIAL_MEDIA_ENTRIES: readonly SocialMediaEntry[] = [
  {
    id: 'youtube',
    label: 'YouTube',
    url: 'https://www.youtube.com/@sadecebilgisayar3865',
    username: '@sadecebilgisayar3865',
    iconClass: 'fab fa-youtube',
    linkClass: 'text-danger',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    url: '',
    username: '@sadecebilgisayar',
    iconClass: 'fab fa-instagram',
    linkClass: 'text-danger',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    url: '',
    username: '@sadecebilgisayar',
    iconClass: 'fab fa-facebook',
    linkClass: 'text-primary',
  },
];
